const formatTimeDifference = (timestamp) => {
    const now = Math.floor(Date.now() / 1000); // Current time in seconds
    const diffInSeconds = timestamp > now ? timestamp - now : now - timestamp;
    
    const hours = Math.floor(diffInSeconds / 3600);
    const minutes = Math.floor((diffInSeconds % 3600) / 60);
    const seconds = diffInSeconds % 60;
  
    if (timestamp > now) {
      // Future timestamp (e.g., end time)
      return `${hours} hours ${minutes} minutes${seconds > 0 ? ` ${seconds} seconds` : ''} left`;
    } else {
      // Past timestamp (e.g., start time)
      return `${hours > 0 ? `${hours} hours ` : ''}${minutes} minutes${seconds > 0 ? ` ${seconds} seconds` : ''} ago`;
    }
  };

  const isProposalApproved = (proposal) => {
    const { scores = [], state, choices = [] } = proposal;
  
    if (state !== "closed") return null; // Still voting
  
    const indexOfApprove = choices.findIndex(c => c.toLowerCase() === 'approve');
    const indexOfReject = choices.findIndex(c => c.toLowerCase() === 'reject');
  
    const approveVotes = scores[indexOfApprove] || 0;
    const rejectVotes = scores[indexOfReject] || 0;
  
    return approveVotes > rejectVotes ? 'Approved' : 'Rejected';
  };

  export {formatTimeDifference, isProposalApproved}

